module.exports = __webpack_public_path__ + "static/media/emojiDisappointed.5801f1b6.svg";